<template>
    <form-container :header="translate('jobRevise.jobReviseForm')" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col col-8">
                   <table class="table table-borderless table-sm ozet">
                        <tbody>
                            <tr>
                                <td style="width:1px">{{translate('draft.referenceJob')}}</td>
                                <td>:</td>
                                <td>
                                    <router-link target="_blank" :to="{ name: 'JobMyDetail', params: { id : data.JobId } }">
                                        {{data.TrackingNo | trackingNo}}
                                    </router-link> —
                                    {{data.Title}}
                                </td>
                            </tr>
                            <tr>
                                <td>{{translate('jobRevise.reviseReason')}}</td>
                                <td>:</td>
                                <td>
                                    <!-- <textarea class="form-control" rows="2" v-model="data.Description" maxlength="2000" placeholder="Lütfen iş akışı için revize gerekçenizi giriniz."></textarea> -->
                                    <text-area-input v-model="data.Description" className="form-control" :maxlength="2000" rows="2" :placeholder="translate('jobRevise.reviseReasonText')" />
                                </td>
                            </tr>

                            <tr>
                                <td>{{translate('draft.signApproveSteps')}}</td>
                                <td>:</td>
                                <td>

                                </td>
                            </tr>
                        </tbody>
                   </table>
                                    <step-editor
                                    ref="stepEditor"
                                    class="form-control"
                                    style="height:400px; overflow-y:auto; padding: 16px 16px 16px 0;"
                                    :key="data.JobId"
                                    v-model="data.Steps"
                                    :user-list="availableUserList"
                                    :editable="true"
                                    ></step-editor>
                                    <button type="button" style="margin-top:16px;" class="btn btn-sm btn-outline-secondary float-right" @click="$refs.stepEditor.addStep()"><icon-plus/> {{translate('circulationProfileSchema.addStep')}}</button>
            </div>
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col col-8"> 
                    <div class="row">
                        <div class="col">
                            <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                        </div>
                        <div class="col text-right">
                            <button type="submit" accesskey="k" class="btn btn-success">{{translate('save')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </form-container>
    
</template>

<script>
import axios from 'axios'
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import stepEditor from "../components/StepEditor.vue";
import TextAreaInput from '@/components/TextAreaInput.vue';

import iconPlus from '../components/Icons/plus.svg';

export default {
    mixins: [formMixin],
    components: {
        formContainer,
        stepEditor,
        TextAreaInput,
        iconPlus
    },
    
    created(){
        this.getUsers({ predicate: "IsActive= true" })
        .then((x) => {
            this.userList = x.Result.sort((a, b) => {
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
            });

            console.log(this.userList);
        })
        .catch((x) => {
            console.log("Kullanıcı listesi yüklenemedi:", x);
        });
        this.getData(this.$route.params.id, true, this.$route.query.kind);
    },
    data() {
        return {
            loading: false,
            modelName: 'JobRevise',
            data: {},
            userList: null
        }
    },
    computed: {
        availableUserList() {
            if (!this.userList) return [];

            if (this.CirculationProfileSchemaId || this.hasAuth("Admin"))
                return this.userList;

            var userDepartmentIds = this.$root.$data.login.User.DepartmentIds;
            if (!userDepartmentIds || userDepartmentIds.length == 0)
                return this.userList;

            var result = this.userList.filter(
                (x) =>
                x.Departments == null ||
                x.Departments.length == 0 ||
                x.Departments.some((d) =>
                    userDepartmentIds.some((udId) => udId == d.Id)
                )
            );

            return result;
            }
    },
    methods: {
        save(){
            this.loading = true;
            this.errorMessage = null;
            return axios
              .post(`/${this.modelName}/post/${this.data.Id}`, this.data)
              .then(x => {
                console.log("SAVE Result:", x.data);
                this.$router.push({ name: 'JobMyDetail', params: { id: x.data.Id } });
                return x;
              })
              .catch(x => {
                   window.processErrorResponse(x, this);
                   this.loading = false;
              });
        },
        goBack(){
            this.$router.go(-1);
        }
    }
}
</script>